<template>
  <div class="p-12">
    <div class="max-w-5xl mx-auto">
      <div class="space-y-16">
        <div class="flex items-center justify-between">
          <h4 class="text-indigo-500 capitalize">lists</h4>

          <RouterLink
            v-if="$membershipHasPermissionTo('create contact lists')"
            :to="{ name: 'accounts.contactLists.create', params: { accountId } }"
            class="btn btn-brand px-6 capitalize"
          >
            new list
          </RouterLink>
        </div>

        <BaseAdvancedList searchable :loading="pending" :entities="contactLists" :meta="meta">
          <template #header>
            <ListHeader />
          </template>

          <template #default="listProps">
            <ListItem :contact-list="listProps.entity" />
          </template>
        </BaseAdvancedList>
      </div>
    </div>
  </div>
</template>

<script>
import ListHeader from '@/components/AccountContactList/ListHeader.vue';
import ListItem from '@/components/AccountContactList/ListItem.vue';
import { middleware } from '@/routes/guards';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';

export default {
  components: {
    ListHeader,
    ListItem,
  },
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    pending: false,
  }),
  computed: {
    ...mapState('ui/accountContactLists', ['meta']),
    ...mapGetters('ui/accountContactLists', ['contactLists']),
  },
  watch: {
    $route: 'fetchData',
  },
  beforeRouteEnter: middleware('account-permission:read contact lists'),
  created() {
    this.fetchData();
  },
  destroyed() {
    this.setIds([]);
    this.setMeta(null);
    this.setLinks(null);
  },
  methods: {
    ...mapActions('ui/accountContactLists', {
      loadContactLists: 'load',
    }),
    ...mapMutations('ui/accountContactLists', ['setIds', 'setMeta', 'setLinks']),
    async fetchData() {
      const { accountId } = this;
      const { query: params } = this.$route;
      this.pending = true;
      try {
        await this.loadContactLists({
          accountId,
          params: {
            ...params,
            include: 'active_subscriptions_count',
          },
        });
      } catch (error) {
        //
      }
      this.pending = false;
    },
  },
};
</script>
